/*
    创建者：shuxiaokai
    创建时间：2020-05-13 11:38
    模块名称：时间选择
    备注：xxxx
*/
<template>
    <div class="s-time-select">
        <el-tooltip effect="dark" transition="none" content="2018，2019，2020年" placement="bottom">
            <div class="select-item">近三年</div>
        </el-tooltip>
        <el-tooltip disabled effect="dark" transition="none" content="2020年" placement="bottom">
            <div class="select-item">2020</div>
        </el-tooltip>
        <el-tooltip disabled effect="dark" transition="none" content="2019年" placement="bottom">
            <div class="select-item">2019</div>
        </el-tooltip>
        <el-tooltip disabled effect="dark" transition="none" content="2019年" placement="bottom">
            <div class="select-item">2018</div>
        </el-tooltip>
        <div class="mr-2 gray-400">|</div>
        <el-tooltip disabled effect="dark" transition="none" content="2019年" placement="bottom">
            <s-tooltip :isShow.sync="isShowContent" title="自定义日期选择">
                <div class="more" @click="isShowContent = true">
                    <i class="f-sm el-icon-setting"></i>&nbsp;
                    <span>自定义</span>
                </div>
                <div slot="content" class="time-content">
                    <div class="px-3 d-flex a-center j-center my-1">
                        <div class="flex0">日期范围：</div>
                        <el-date-picker v-model="time" value-format="yyyy-MM-dd" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" size="mini" class="w-100"></el-date-picker>
                    </div>
                    <!-- <div class="px-3 d-flex a-center j-center my-1">
                        <div class="flex0">常用日期：</div>
                    </div> -->
                </div>
            </s-tooltip>
        </el-tooltip>
    </div>
</template>

<script>
export default {
    data() {
        return {
            time: [],
            isShowContent: false,
            //=====================================日期参数====================================//
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {},
    methods: {
        //=====================================获取远程数据==================================//
        //=====================================前后端交互====================================//
        //=====================================组件间交互====================================//
        //=====================================其他操作=====================================//
    }
};
</script>



<style lang="scss">
.s-time-select {
    display: flex;
    align-items: center;
    // 可选日期
    .select-item,
    .more {
        cursor: pointer;
        font-size: fz(12);
        padding: size(5) size(10);
        border: 1px solid $gray-300;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: size(10);
        border-radius: $border-radius-sm;
        &:hover {
            background: $gray-200;
        }
        &.active {
            transition: background 0.3s;
            color: $white;
            background: $theme-color;
        }
    }
    // 更多筛选
    .more {
    }
    .time-content {
        width: size(400);
        height: size(50);
        position: relative;
    }
}
</style>
